const WishlistMail = (function(window, $) {

    function WishlistMail(target) {
        this.$element = $(target);
        this.$form = this.$element.find('form');
        this.$forminput = this.$element.find('.form-group input');
        this.$success = this.$element.find('.wishlist-mail-success').hide();
        this.$error = this.$element.find('.wishlist-mail-error').hide();
        this.addEvents();
    }

    WishlistMail.prototype.addEvents = function() {
        this.$form.on('submit', this.submit.bind(this));
        this.$forminput.on('focusin', this.modifyState.bind(this));
    };

    WishlistMail.prototype.submit = function(e) {

        e.preventDefault();

        this.$success.hide();
        this.$error.hide();

        $.ajax(window.ajaxURL, {
            type: 'POST',
            data: this.$form.serialize()
        }).done(function (data) {
            this.$success.show();
            this.$form.fadeOut('fast');
        }.bind(this)).fail(function () {
            this.$error.fadeIn('fast');
            this.$form.addClass('invalid');
        }.bind(this));
    };

    WishlistMail.prototype.modifyState = function() {
        this.$form.removeClass('invalid');
        this.$error.fadeOut('fast');
    }

    return WishlistMail;

}(window, jQuery));

export {WishlistMail};
